import { Checkbox, Switch } from 'antd'
import { useSelector, useDispatch } from 'react-redux'
import dayjs from 'dayjs'
import $t from '../../../../i18n'
import CollapseDetails from '../../../common/CollapseDetails'
import Actions from '../../../../actions'
import './PaymentRow.css'

function PaymentRow({ paymentPlanDetails, editable = true }) {
  const dispatch = useDispatch()
  const { zuoraSignatureDetails } = useSelector(state => state.payment)
  const { price } = zuoraSignatureDetails
  const paymentConfig = useSelector(
    state =>
      state.payment.paymentConfigPerSubscriptions[
        paymentPlanDetails?.subscriptionId
      ]
  )

  const updatePaymentConfig = (subscriptionId, configChanges) => {
    dispatch(
      Actions.createAction(Actions.UPDATE_PAYMENT_CONFIG_SUBSCRIPTION, {
        subscriptionId,
        config: configChanges
      })
    )
  }

  const hasDueBalance = () => {
    return paymentPlanDetails?.dueBalance > 0
  }

  const hasOverdueBalance = () => {
    return paymentPlanDetails?.overdueBalance > 0
  }

  const overdueBalanceWithCheckbox = () => {
    return (
      <div className='amount-box'>
        <Checkbox checked={true} disabled>
          <span className='amount-text semi-bold'>
            ${parseFloat(paymentPlanDetails?.overdueBalance).toFixed(2)}
          </span>
        </Checkbox>
        <span className='amount-info-text'>
          <i className='icon-danger' /> {$t('pages.billing.overdueAmountRow')} |{' '}
          <span className='medium'>{$t('pages.billing.required')}</span>
        </span>
      </div>
    )
  }

  const dueBalanceWithCheckbox = () => {
    return (
      <div className='amount-box'>
        <Checkbox
          checked={paymentConfig?.includeDue}
          disabled={paymentConfig?.excluded || !editable}
          onChange={e =>
            updatePaymentConfig(paymentPlanDetails?.subscriptionId, {
              includeDue: e.target.checked,
              excluded: false
            })
          }
        >
          <span className='amount-text semi-bold'>
            ${parseFloat(paymentPlanDetails?.dueBalance).toFixed(2)}
          </span>
        </Checkbox>
        <span className='amount-info-text'>
          <i className='icon-clock' /> {$t('pages.billing.amountDueBy')}{' '}
          {dayjs(paymentPlanDetails?.dueDate).format('MMMM D, YYYY')}
        </span>
      </div>
    )
  }

  const hasOverdueAndDueBalances = () => {
    return hasOverdueBalance() && hasDueBalance()
  }

  return (
    <div
      className={`payment-row-subscription-details ${
        paymentConfig?.excluded ? 'excluded' : ''
      }`}
    >
      {editable && (
        <div className='payment-row-switch-container'>
          <Switch
            checked={!paymentConfig?.excluded}
            onChange={checked =>
              updatePaymentConfig(paymentPlanDetails?.subscriptionId, {
                excluded: !checked
              })
            }
          />
        </div>
      )}
      <div className='price-details-card'>
        <div className='price-details-card-header'>
          <div className='invoice-label-black semi-bold'>
            {dayjs(paymentPlanDetails?.effectiveInvoicePeriodDate).format(
              'MMM YYYY'
            )}{' '}
            {$t('pages.paymentDetails.premium')}
          </div>
          <div className='invoice-label'>
            {$t('pages.billing.invoiceDate')}:{' '}
            {dayjs(paymentPlanDetails?.invoiceDate).format('MMM D, YYYY')}
          </div>
          <div className='invoice-label'>
            {$t('pages.billing.invoiceNumber')}:{' '}
            {paymentPlanDetails?.invoiceNumber}
          </div>
        </div>
        <CollapseDetails
          backgroundColor='var(--color_purple_p100)'
          headerComponent={
            <div className='price-details'>
              <div>
                {!paymentPlanDetails?.isCouponApplied && (
                  <span className='price-value'>
                    ${parseFloat(paymentPlanDetails?.planPrice).toFixed(2)}{' '}
                  </span>
                )}
                {paymentPlanDetails?.isCouponApplied && (
                  <h1 className='price-value semi-bold'>
                    <s>$ {paymentPlanDetails?.planPrice}</s> ${price}
                    {paymentPlanDetails?.isAutoPay &&
                      $t('pages.billing.untilCoupon')}
                  </h1>
                )}
              </div>
            </div>
          }
          contentComponent={
            <>
              <div className='name-details section'>
                <div className='semi-bold'>{paymentPlanDetails?.planName}</div>
                {paymentPlanDetails?.planDescription && (
                  <div className='description'>
                    {paymentPlanDetails?.planDescription}
                  </div>
                )}
              </div>
              <>
                <div className='price-details section'>
                  {hasOverdueAndDueBalances() ? (
                    <div className='price-details-field'>
                      {overdueBalanceWithCheckbox()}
                      {dueBalanceWithCheckbox()}
                    </div>
                  ) : hasOverdueBalance() ? (
                    <div className='amount-box'>
                      <span className='amount-text semi-bold'>
                        $
                        {parseFloat(paymentPlanDetails?.overdueBalance).toFixed(
                          2
                        )}
                      </span>
                      <span className='amount-info-text'>
                        <i className='icon-danger' />
                        {$t('pages.billing.overdueAmountRow')} |{' '}
                        <span className='medium'>
                          {$t('pages.billing.required')}
                        </span>
                      </span>
                    </div>
                  ) : hasDueBalance() ? (
                    <div className='amount-box'>
                      <span className='amount-text semi-bold'>
                        ${parseFloat(paymentPlanDetails?.dueBalance).toFixed(2)}
                      </span>
                      <span className='amount-info-text'>
                        <i className='icon-clock' />
                        {$t('pages.billing.amountDueBy')}{' '}
                        {dayjs(paymentPlanDetails?.dueDate).format(
                          'MMMM D, YYYY'
                        )}
                      </span>
                    </div>
                  ) : null}
                </div>
              </>
            </>
          }
        />
      </div>
    </div>
  )
}

export default PaymentRow
